<vp-footer
	[bottomItems]="bottomMenu() | menuItems"
	[editableInStoryblok]="_editable"
	[information]="hotelStore.hotelMainContact()"
	[menu]="{ items: footerMenuItems() }"
	[socials]="socials()"
	[title]="hotelStore.slug() || title()"
	[usps]="usps() | menuItems"
/>
